<template>
  <v-dialog v-model="show" max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              type="text"
              v-model="object.nombre"
              label="Nombre"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              type="text"
              v-model="object.fecha_inicio"
              label="Fecha Inicio"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              type="text"
              v-model="object.fecha_fin"
              label="Fecha Fin"
            ></v-text-field>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="object" color="blue darken-1" text @click="close">
              Volver
            </v-btn>
            <v-btn v-else color="blue darken-1" text @click="close">
              Cancelar
            </v-btn>
            <v-btn v-if="!detalle" color="blue darken-1" text @click="guardar">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      imageDefault: "https://futureuniversity.com/wp-content/uploads/sites/3/2015/02/default-placeholder-1024x1024-570x321.png",
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
    detalle: Boolean,
  },
  computed: {
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edición de registro";
      } else if (me.detalle) {
        titulo = "Detalle";
      } else {
        titulo = "Nuevo registro";
      }
      // this.update ? "Edución de registro" : "Nuevo registro";
      return titulo;
    },
  },
  methods: {
    selectImage(url) {
      debugger
      this.dialog = false;
      this.object.imagen = url;
    },
    galleryFn() {
      this.dialog = true;
    },
    guardar() {
      debugger
      this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
